import { ILink } from "../../base/Button/Button.map";

interface INewsletterSignUp {
  title: string;
  completeTitle: string;
  body: string;
  completeBody: string;
  buttonText: string;
  placeholder?: string;
  policyNotice?: string;
}
export interface IFooterLinkGroup {
  id: string;
  title: string;
  links: ILink[];
}
export interface IFooterData {
  newsLetterSignUp: INewsletterSignUp;
  primaryLinkGroup: IFooterLinkGroup;
  secondaryLinkGroups: IFooterLinkGroup[];
  tertiaryLinks: ILink[];
}

export const FOOTER_DATA: IFooterData = {
  newsLetterSignUp: {
    title: "Join KatKin",
    completeTitle: "You're in!",
    body: "Sign up for hardcore news, cat education and exclusive offers.",
    completeBody: "Check your inbox to hear more from KatKin.",
    buttonText: "Sign up",
  },
  primaryLinkGroup: {
    id: "plg-1",
    title: "Articles",
    links: [
      {
        id: "plg-1-a",
        name: "KatKin vs Dry cat food",
        to: "/dry-cat-food",
      },
      {
        id: "plg-1-b",
        name: "KatKin vs Wet cat food",
        to: "/wet-cat-food",
      },
      {
        id: "plg-1-c",
        name: "KatKin vs Raw cat food",
        to: "/raw-cat-food",
      },
      {
        id: "plg-1-d",
        name: "KatKin vs High protein cat food",
        to: "/high-protein-cat-food",
      },
      {
        id: "plg-1-e",
        name: "KatKin for Kittens",
        to: "/kitten-food",
      },
      {
        id: "plg-1-f",
        name: "Cat breeds",
        to: "/cat-breeds",
      },
    ],
  },
  secondaryLinkGroups: [
    {
      id: "slg-1",
      title: "Try Fresh",
      links: [
        {
          id: "slg-1-a",
          name: "Start my Trial",
          to: "/forms/fresh-new-user",
        },
        {
          id: "slg-1-b",
          name: "Why fresh",
          to: "/why-fresh",
        },
        {
          id: "slg-1-c",
          name: "Our products",
          to: "/products",
        },
        {
          id: "slg-1-d",
          name: "Breeder Club",
          to: "/breeder",
        },
        // {
        //   id: "slg-1-e",
        //   name: "Food safety",
        //   to: "/no-shortcuts-on-food-safety",
        // },
      ],
    },
    {
      id: "slg-2",
      title: "About KatKin",
      links: [
        {
          id: "slg-2-a",
          name: "About us",
          to: "/about-us",
        },
        {
          id: "slg-2-b",
          name: "Learn",
          to: "/articles",
        },
        {
          id: "slg-2-c",
          name: "Refer a friend",
          to: "/refer-a-friend?situation=web_footer",
        },
        {
          id: "slg-2-d",
          name: "Press",
          to: "/articles/katkin-raises-22m-series-a-funding",
        },
        {
          id: "slg-2-e",
          name: "Careers",
          to: "https://katkin.jobs.personio.com/",
        },
      ],
    },
    {
      id: "slg-3",
      title: "Follow us",
      links: [
        {
          id: "slg-3-a",
          name: "Instagram",
          to: "https://www.instagram.com/katkin.club/?hl=en",
        },
        {
          id: "slg-3-b",
          name: "Facebook",
          to: "https://www.facebook.com/groups/katkin.clubhouse",
        },
        {
          id: "slg-3-c",
          name: "YouTube",
          to: "https://www.youtube.com/channel/UC54z0neHFbv6c5M3dNdBhgQ",
        },
        {
          id: "slg-3-d",
          name: "LinkedIn",
          to: "https://www.linkedin.com/company/katkin/",
        },
      ],
    },
    {
      id: "slg-4",
      title: "Help",
      links: [
        {
          id: "slg-4-a",
          name: "My Account",
          to: "/login",
        },
        {
          id: "slg-4-b",
          name: "FAQs",
          to: "https://help.katkin.com/en",
        },
        {
          id: "slg-4-c",
          name: "Contact Us",
          to: "https://help.katkin.com/en/articles/439320-contacting-our-customer-experience-team",
        },
        {
          id: "slg-4-d",
          name: "Shipping and Delivery",
          to: "https://help.katkin.com/en/articles/431331-delivery-dates-locations-and-charge-deadlines",
        },
        {
          id: "slg-4-e",
          name: "Reviews",
          to: "https://uk.trustpilot.com/review/katkin.club",
        },
      ],
    },
  ],
  tertiaryLinks: [
    {
      id: "tl-1",
      name: "Terms & Conditions",
      to: "/legal/terms",
    },
    {
      id: "tl-2",
      name: "Privacy",
      to: "/legal/privacy-policy",
    },
    {
      id: "tl-3",
      name: "Sitemap",
      to: "/sitemap",
    },
    {
      id: "tl-4",
      name: "Cookie Settings",
      to: "/legal/privacy-policy",
    },
  ],
};
